import { queryKeys } from '@/utils/constants';

const MODULE_KEY = 'teams';

/** Query Key Getters */

export const getTeamsQueryKey = () => [MODULE_KEY, queryKeys.ALL_TEAMS];

export const getTeamPositionsQueryKey = (teamTwrn?: string | null) => {
  const key = [MODULE_KEY, queryKeys.TEAM_POSITIONS];
  if (teamTwrn) {
    key.push(teamTwrn);
  }
  return key;
};

export const getTagsQueryKey = (orgTwrn?: string | null, teamTwrn?: string | null) => {
  const key = [MODULE_KEY, queryKeys.TAGS];
  if (orgTwrn) {
    key.push(orgTwrn);
    if (teamTwrn) {
      key.push(teamTwrn);
    }
  }

  return key;
};
